var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"center"}},[_c('div',{staticStyle:{"height":"6rem","padding":"0.1rem"},attrs:{"id":"sb"}})])}]

export { render, staticRenderFns }